import type { ReactNode } from 'react';

interface RewardsSubpageChromeProps {
  onBack: () => void;
  children: ReactNode;
}

/** Shared back row + scroll region used by About Tiers, How To Reach Tier, etc. */
export function RewardsSubpageChrome({ onBack, children }: RewardsSubpageChromeProps) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxSizing: 'border-box',
        padding: '0 0 14px',
        background: '#0b0618',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          height: 22,
          marginBottom: 12,
          flexShrink: 0,
        }}
      >
        <button
          type="button"
          onClick={onBack}
          style={{
            border: 'none',
            background: 'transparent',
            padding: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            height: 22,
          }}
        >
          <span style={{ margin: 0, color: '#8d8aa8', fontSize: 12, lineHeight: '22px', fontWeight: 700 }}>
            ← Back
          </span>
        </button>
        <div style={{ width: 22, height: 22, flexShrink: 0 }} aria-hidden="true" />
      </div>

      <div
        className="hr-scroll"
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {children}
      </div>
    </div>
  );
}

/** Machine Tier hero block (About Tiers / How To Reach Tier). */
export function RewardsMachineTierHero({
  eyebrow,
  title,
  titleColor,
  titleFontSize = 42,
  titleSingleLine = false,
  subtitle,
}: {
  eyebrow?: string;
  title: string;
  titleColor: string;
  titleFontSize?: number;
  titleSingleLine?: boolean;
  subtitle?: string;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%', alignItems: 'center' }}>
      {eyebrow ? (
        <p style={{ margin: 0, color: '#cccccc', fontSize: 14, lineHeight: '20px', fontWeight: 700, textAlign: 'center' }}>
          {eyebrow}
        </p>
      ) : null}
      <p
        style={{
          margin: 0,
          color: titleColor,
          fontSize: titleFontSize,
          lineHeight: 1.1,
          fontWeight: 700,
          textAlign: 'center',
          whiteSpace: titleSingleLine ? 'nowrap' : 'normal',
        }}
      >
        {title}
      </p>
      {subtitle ? (
        <p
          style={{
            margin: '2px 0 0',
            color: '#8d8aa8',
            fontSize: 11,
            lineHeight: '16px',
            fontWeight: 500,
            textAlign: 'center',
            maxWidth: 260,
          }}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
